module.exports = __webpack_public_path__ + "img/4992.ed72d5e8.jpg";